import graphqlClient from "@/GQLClient";
import {
  GetDepartmentListDocument,
  GetExternalDepartmentListDocument,
  Module_Type,
  type GetDepartmentListQuery,
  type GetExternalDepartmentListQuery,
} from "@/graphql/generated-types";
import { GraphQLError } from "graphql";

const getDepartments = async (): Promise<GetDepartmentListQuery> => {
  const response = await graphqlClient.query({
    query: GetDepartmentListDocument,
  });

  if (response.data.institutions?.getMyInstitution.departments) {
    return response.data;
  }

  throw new GraphQLError(`api.departmets.getDepartments`);
};

const getExternalDepartments = async (
  type: Module_Type,
): Promise<GetExternalDepartmentListQuery> => {
  const response = await graphqlClient.query({
    query: GetExternalDepartmentListDocument,

    variables: {
      type,
    },
  });

  if (response.data.institutions?.getMyInstitution.externalDepartments) {
    return response.data;
  }

  throw new GraphQLError(`api.departmets.getDepartments`);
};

export default {
  getDepartments,
  getExternalDepartments,
};
